import React from "react";
import {PageHeading} from "peggirkit";
import {generateBreadcrumbs} from "../../../layout/Breadcrumbs";
import {Route} from "@/routing/Router";
import {useIntl} from "react-intl";
import {FeaturedProductDetails} from "@/data/entities/product";
import {SetStateFn} from "@/utils/SetStateUtils";
import FeaturedProductHeadingActions from "@widgets/featuredProducts/editor/heading/FeaturedProductHeadingActions";
import LocationPageMeta from "@widgets/heading/meta/LocationPageMeta";

type Props = {
    route: Route,
    initialLoading: boolean,
    featuredProduct: FeaturedProductDetails | null,
    setFeaturedProduct: SetStateFn<FeaturedProductDetails | null>,
    setShowDeleteModal: SetStateFn<boolean>,
};

const FeaturedProductHeading = ({route, initialLoading, featuredProduct, setFeaturedProduct, setShowDeleteModal}: Props) => {
    const intl = useIntl();

    return (
        <PageHeading
            breadcrumbs={generateBreadcrumbs(route, intl)}
            title={initialLoading ? intl.formatMessage(({id: "featuredProduct"})) : route.name(intl)}
            actionRowHorizontal={false}
            actionRow={
                featuredProduct === null
                    ? undefined
                    : <FeaturedProductHeadingActions
                        setShowDeleteModal={setShowDeleteModal}
                        setFeaturedProduct={setFeaturedProduct}
                    />
            }
            meta={<LocationPageMeta/>}
            breakpoints={{md: {actionRowHorizontal: true}}}
        />
    );
};

export default FeaturedProductHeading;